let logon_template = 'sign-in.vue';
let background_images = null;
let syslogo = null;
let menu_class = 'el-menu-vertical-demo';
let functions = false;
let enroll = false;
let report_name = '会议统计';
let use_label = false;
let no_default_group = false;
let hidden_group = ['学院管理','会议室','会议室会议'];
let auto_record = 0;
let cohost = true;

//以下内容需要进行修改或者增加
if (process.env.VUE_APP_API_ORG === 'sufe') {
    logon_template = 'sign-in-sufe.vue';
} else if (process.env.VUE_APP_API_ORG === 'sjtu') {
    logon_template = 'sign-in-sjtu.vue';
    background_images = ["bg1.jpg", "bg2.jpg", "bg3.jpg", "bg4.jpg", "bg5.jpg", "bg6.jpg", "bg7.jpg"]
} else if (process.env.VUE_APP_API_ORG === 'tsied') {
    //logon_template = 'sign-in-tsied.vue'
    functions = true;
    enroll = true;
} else if (process.env.VUE_APP_API_ORG === 'shu') {
    background_images =
        ['20191192.jpg',
            '201911084.jpg',
            '20191029.jpg',
            '20191109.jpg'];
    logon_template = 'sign-in.vue';
} else if (process.env.VUE_APP_API_ORG === 'sou') {
    background_images =
        ['sou-bg1.jpg'];
    logon_template = 'sign-in.vue';
} else if (process.env.VUE_APP_API_ORG === 'age06') {
    background_images =
        ['shec-bg1.jpg', 'shec-bg2.jpg', 'shec-bg3.jpg'];
    logon_template = 'sign-in-shec.vue';
    syslogo = 'syslogo.png';
} else if (process.env.VUE_APP_API_ORG === 'fudan') {
    background_images =
        ['fudan-bg1.jpg', 'fudan-bg2.jpg', 'fudan-bg3.jpg'];
    logon_template = 'sign-in.vue';
    report_name = '报表';
} else if (process.env.VUE_APP_API_ORG === 'ecust') {
    background_images =
        ['ecust-001.jpg', 'ecust-002.jpg', 'ecust-003.jpg', 'ecust-004.jpg', 'ecust-005.jpg'];
    logon_template = 'sign-in.vue';
} else if (process.env.VUE_APP_API_ORG === 'publics') {
    logon_template = 'sign-in-public.vue';
    syslogo = 'syslogo.png';
} else if (process.env.VUE_APP_API_ORG === 'shanghaitech') {
    logon_template = 'sign-in-shanghaitech.vue';
    menu_class = "el-menu-light-gray"
    document.getElementsByTagName('body')[0].style.setProperty('--sign-in-primary', '#a10003')
    document.getElementsByTagName('body')[0].style.setProperty('--sign-in-primary-hover', '#de3d40')
} else if (process.env.VUE_APP_API_ORG === 'shwfl') {
    menu_class = "el-menu-light-gray";
    functions = true;
} else if (process.env.VUE_APP_API_ORG === 'tongji') {
    background_images =
        ['tongji001.jpg', 'tongji002.jpg', 'tongji003.jpg'];
} else if (process.env.VUE_APP_API_ORG === 'ecnu' || process.env.VUE_APP_API_ORG === 'ecnu-yjs') {
    logon_template = 'sign-in-ecnu.vue';
} else if (process.env.VUE_APP_API_ORG === 'seu') {
    background_images =
        ['seu-bg-1.jpg', 'seu-bg-2.jpg', 'seu-bg-3.jpg'];
} else if (process.env.VUE_APP_API_ORG === 'bnu') {
    functions = true;
    background_images = ['bnu-bg1.jpg', 'bnu-bg2.jpg', 'bnu-bg3.jpg'];
    no_default_group = true;
    cohost = false;

} else if (process.env.VUE_APP_API_ORG === 'mhedu') {
    menu_class = "el-menu-light-gray"
    use_label = true;
    auto_record= 2;
    hidden_group = ['用户类型','会议室管理','会议室','会议室会议','背景图片','代建会议'];

    document.getElementsByTagName('body')[0].style.setProperty('--sign-in-primary', '#a10003')
    document.getElementsByTagName('body')[0].style.setProperty('--sign-in-primary-hover', '#de3d40')
}

//以上内容进行修改和增加
//这是交大特殊用法，一定要邮件地址登录
//其他学校可以多重方式登录
const use_id = process.env.VUE_APP_API_ORG !== 'sjtu';
const signin = process.env.VUE_APP_API_ROOT ? process.env.VUE_APP_API_ROOT : window.location.origin + '/api/v1'
const signin_url = signin.replace('api/v1', 'sign-in')
const host_url = signin.replace('api/v1', '');
const home_page = process.env.VUE_APP_HOME ? process.env.VUE_APP_HOME : '/calendar';
const edit_page = process.env.VUE_APP_EDIT ? process.env.VUE_APP_EDIT : false;

const hideMenu = (name) => {
    // 判断 hidden_group 中是否包含 name
    return hidden_group.indexOf(name) > -1
}
// 导出内容
export default {
    //如果设置sso，则不显示登录页面，直接跳转到sso的页面
    sso: process.env.VUE_APP_SSO_LOGIN_REDIRECT,
    sso_out: process.env.VUE_APP_SSO_LOGOUT_REDIRECT,
    //学校的org缩写
    org: process.env.VUE_APP_API_ORG,
    //使用user_id还是使用email
    use_id: use_id,
    //登录的template
    logon_template: logon_template,
    //oauth的设置
    oauth: process.env.VUE_APP_OAUTH_LOGIN,
    oauth_out: process.env.VUE_APP_OAUTH_LOGOUT,
    oauth_title: process.env.VUE_APP_OAUTH_TITLE,
    oauth_picture: process.env.VUE_APP_OAUTH_PICTURE,
    oauth_helper: process.env.VUE_APP_OAUTH_HELPER,
    //微信的设置
    wx_redirect: process.env.VUE_APP_API_WX_CORP_REDIRECT,
    //这个不用了
    h323: process.env.VUE_APP_ORG_H323,
    //背景图片，这个也不用了。可以自己上传
    background_images: background_images,
    //系统的logo
    syslogo: syslogo,
    //系统登录的url
    signin_url: signin_url,
    //系统登录的url
    host_url: host_url,

    no_qrcode: process.env.VUE_APP_NO_QRCODE,
    home_page: home_page,
    edit_page: edit_page,
    no_indicate: process.env.VUE_APP_NO_INDICATE,
    build_time: process.env.VUE_APP_BUILD_TIME,
    //多学校设置
    extra: process.env.VUE_APP_MULTI_UNIVERSITY,
    //不使用zoom
    no_zoom: process.env.VUE_APP_API_NO_ZOOM,
    //不使用腾讯
    no_tencent: process.env.VUE_APP_API_NO_TENCENT,
    //不使用we-link
    no_welink: process.env.VUE_APP_API_NO_WELINK,
    //腾讯使用contract
    use_contact: process.env.VUE_APP_USE_CONTACT,
    //使用微信
    use_wechat: process.env.VUE_APP_USE_WECHAT,
    wechat_appid: process.env.VUE_APP_WECHAT_APPID,
    wechat_agentid: process.env.VUE_APP_WECHAT_AGNETID,
    //menu
    menu_class: menu_class,
    //sign-in-functions
    sign_in_functions:functions,
    //allow_enroll
    allow_enroll:enroll,
    //homejs name
    menu_report_name:report_name,
    //只有闵行教育局使用label
    use_label:use_label,
    no_default_group:no_default_group,
    auto_record:auto_record,
    cohost:cohost,
    hidden: hideMenu,
    encrypt_token: process.env.VUE_APP_ENCRYPT_TOKEN,

}
